module.exports = "<button v-icon-button=icon v-title=title @click=\"$emit('toggle')\"/> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/common/image-viewer/templates/image-viewer-fullscreen-toggle.html
// module id = 20
// module chunks = 1 2